/* Modulo Photo Reviews — photo-paired testimonial carousel.
   Vanilla IIFE, lazy-init, reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function initSection(el) {
    var track = el.querySelector('[data-modulo-tp-track]');
    if (!track) return;

    var prev    = el.querySelector('[data-modulo-tp-prev]');
    var next    = el.querySelector('[data-modulo-tp-next]');
    var dots    = el.querySelector('[data-modulo-tp-dots]');
    var cards   = function () { return track.querySelectorAll('[data-modulo-tp-card]'); };

    var trunc = parseInt(el.getAttribute('data-truncation-lines'), 10);
    if (!trunc || isNaN(trunc)) trunc = 4;
    el.style.setProperty('--modulo-tp-truncation-lines', trunc);

    var moreLabel = el.getAttribute('data-view-more') || 'Read more';
    var lessLabel = el.getAttribute('data-view-less') || 'Show less';
    var stepMode  = el.getAttribute('data-step-mode') === 'page' ? 'page' : 'single';
    var layout    = el.getAttribute('data-layout') || 'grid';
    var isFocusLayout = layout === 'spotlight';

    // ─── Truncation detection + toggle ───
    function detectTruncation() {
      Array.prototype.forEach.call(cards(), function (card) {
        var body = card.querySelector('[data-modulo-tp-body]');
        if (!body) return;
        var wasExpanded = card.classList.contains('is-expanded');
        if (wasExpanded) card.classList.remove('is-expanded');
        if (body.scrollHeight - body.clientHeight > 1) card.classList.add('is-truncated');
        else card.classList.remove('is-truncated');
        if (wasExpanded) card.classList.add('is-expanded');
      });
    }

    function wireToggles() {
      Array.prototype.forEach.call(cards(), function (card) {
        var toggle = card.querySelector('[data-modulo-tp-toggle]');
        var label  = card.querySelector('[data-modulo-tp-toggle-label]');
        if (!toggle || toggle.dataset.bound === '1') return;
        toggle.dataset.bound = '1';
        toggle.addEventListener('click', function () {
          var expanded = card.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (label) label.textContent = expanded ? lessLabel : moreLabel;
        });
      });
    }

    // ─── Carousel ───
    function viewportWidth() { return window.innerWidth || document.documentElement.clientWidth; }

    function cardsPerView() {
      var w = viewportWidth();
      var attr;
      if (w <= 480) attr = 'data-cpv-mobile';
      else if (w <= 860) attr = 'data-cpv-tablet';
      else attr = 'data-cpv-desktop';
      var n = parseInt(el.getAttribute(attr), 10);
      return n && !isNaN(n) ? n : 3;
    }

    // Spotlight default: focus the visually-centered card (middle slot of cpv).
    // Standard grid: start at the first slot.
    var page = isFocusLayout
      ? clamp(Math.floor(cardsPerView() / 2), 0, Math.max(0, cards().length - 1))
      : 0;

    function applyCpv() {
      el.style.setProperty('--modulo-tp-cpv', cardsPerView());
    }

    function pageCount() {
      var total = cards().length;
      var cpv = cardsPerView();
      if (isFocusLayout) return Math.max(1, total);
      if (stepMode === 'single') return Math.max(1, total - cpv + 1);
      return Math.max(1, Math.ceil(total / cpv));
    }

    function applySpotlightFocus() {
      Array.prototype.forEach.call(cards(), function (c, i) {
        c.classList.toggle('is-focus', i === page);
      });
    }

    function goTo(p, animate) {
      var pages = pageCount();
      page = clamp(p, 0, pages - 1);
      var cpv = cardsPerView();
      var firstCard = cards()[0];
      if (!firstCard) return;
      var cardW = firstCard.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(el).getPropertyValue('--modulo-tp-gap')) || 20;
      var offset;
      if (isFocusLayout) {
        // Center the focused card: shift so focus sits in the middle slot.
        // Clamp at edges so we don't expose blank space past start/end.
        var middleSlot = Math.floor(cpv / 2);
        var total = cards().length;
        offset = (page - middleSlot) * (cardW + gap);
        var maxOffset = Math.max(0, (total - cpv) * (cardW + gap));
        offset = Math.max(0, Math.min(maxOffset, offset));
      } else {
        var stride = stepMode === 'single' ? 1 : cpv;
        offset = page * stride * (cardW + gap);
      }
      if (!animate || REDUCE) {
        var prevTransition = track.style.transition;
        track.style.transition = 'none';
        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
        track.offsetHeight;
        track.style.transition = prevTransition;
      } else {
        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page === pages - 1;
      if (isFocusLayout) applySpotlightFocus();
      else el.querySelectorAll('[data-modulo-tp-card]').forEach && Array.prototype.forEach.call(cards(), function (c) { c.classList.remove('is-focus'); });
      renderDots();
    }

    // Click-to-focus on side cards (spotlight only)
    function wireSpotlightClicks() {
      if (!isFocusLayout) return;
      Array.prototype.forEach.call(cards(), function (card, i) {
        if (card.dataset.spotBound === '1') return;
        card.dataset.spotBound = '1';
        card.addEventListener('click', function (e) {
          if (card.classList.contains('is-focus')) return;
          if (e.target.closest('[data-modulo-tp-toggle]')) return;
          if (e.target.closest('a')) return;          // don't hijack Shop overlay clicks
          stopAutoplay();
          goTo(i, true);
        });
      });
    }

    function renderDots() {
      if (!dots) return;
      while (dots.firstChild) dots.removeChild(dots.firstChild);
      var pages = pageCount();
      for (var i = 0; i < pages; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'modulo-tp__dot' + (idx === page ? ' is-active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Page ' + (idx + 1));
          if (idx === page) dot.setAttribute('aria-selected', 'true');
          dot.addEventListener('click', function () {
            stopAutoplay();
            goTo(idx, true);
          });
          dots.appendChild(dot);
        })(i);
      }
    }

    if (prev) prev.addEventListener('click', function () { stopAutoplay(); goTo(page - 1, true); });
    if (next) next.addEventListener('click', function () { stopAutoplay(); goTo(page + 1, true); });

    // ─── Touch swipe ───
    var SWIPE_THRESHOLD = 40;
    var startX = null;
    var startY = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
      startX = e.clientX;
      startY = e.clientY;
    });
    track.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        stopAutoplay();
        if (dx < 0) goTo(page + 1, true);
        else        goTo(page - 1, true);
      }
      startX = null; startY = null;
    });
    track.addEventListener('pointercancel', function () { startX = null; startY = null; });

    // ─── Autoplay ───
    var autoplayTimer = null;
    var autoplayEnabled = el.getAttribute('data-autoplay') === 'true' && !REDUCE;
    var autoplaySpeedSec = parseFloat(el.getAttribute('data-autoplay-speed'));
    if (!autoplaySpeedSec || isNaN(autoplaySpeedSec)) autoplaySpeedSec = 6;

    function startAutoplay() {
      if (!autoplayEnabled || autoplayTimer) return;
      autoplayTimer = window.setInterval(function () {
        var pages = pageCount();
        var nextPage = page + 1 >= pages ? 0 : page + 1;
        goTo(nextPage, true);
      }, autoplaySpeedSec * 1000);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      autoplayEnabled = false;
    }
    el.addEventListener('mouseenter', function () { if (autoplayTimer) { window.clearInterval(autoplayTimer); autoplayTimer = null; } });
    el.addEventListener('mouseleave', function () { startAutoplay(); });

    // ─── Resize ───
    var resizeT;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () {
        applyCpv();
        requestAnimationFrame(function () {
          detectTruncation();
          goTo(0, false);
        });
      }, 100);
    });

    // ─── Video lightbox ───
    function wireLightbox() {
      var lb = el.querySelector('[data-modulo-tp-lightbox]');
      if (!lb) return;
      var frame = lb.querySelector('[data-modulo-tp-lightbox-frame]');
      var closeBtn = lb.querySelector('[data-modulo-tp-lightbox-close]');
      var prevBodyOverflow = '';

      function isYouTube(url) { return /(?:youtube\.com|youtu\.be)/i.test(url); }
      function isVimeo(url)   { return /vimeo\.com/i.test(url); }
      function ytEmbed(url) {
        var m = url.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{11})/);
        return m ? 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1' : url;
      }
      function vimeoEmbed(url) {
        var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        return m ? 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' : url;
      }

      function open(url) {
        var media;
        if (isYouTube(url)) {
          media = document.createElement('iframe');
          media.src = ytEmbed(url);
          media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          media.setAttribute('allowfullscreen', '');
        } else if (isVimeo(url)) {
          media = document.createElement('iframe');
          media.src = vimeoEmbed(url);
          media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          media.setAttribute('allowfullscreen', '');
        } else {
          media = document.createElement('video');
          media.src = url;
          media.controls = true;
          media.autoplay = true;
          media.playsInline = true;
        }
        frame.insertBefore(media, closeBtn);
        lb.removeAttribute('hidden');
        lb.classList.add('is-open');
        prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      function close() {
        var media = frame.querySelector('iframe, video');
        if (media) media.remove();
        lb.classList.remove('is-open');
        lb.setAttribute('hidden', '');
        document.body.style.overflow = prevBodyOverflow;
      }

      Array.prototype.forEach.call(el.querySelectorAll('[data-modulo-tp-play]'), function (btn) {
        if (btn.dataset.lbBound === '1') return;
        btn.dataset.lbBound = '1';
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          stopAutoplay();
          open(btn.getAttribute('data-modulo-tp-play'));
        });
      });
      closeBtn.addEventListener('click', close);
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
      });
    }

    // ─── Boot ───
    applyCpv();
    requestAnimationFrame(function () {
      detectTruncation();
      wireToggles();
      wireSpotlightClicks();
      wireLightbox();
      goTo(0, false);
      startAutoplay();
    });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-tp]', initSection);
    } else {
      Array.prototype.forEach.call(document.querySelectorAll('[data-modulo-tp]'), initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
